import { useIonToast } from "@ionic/react";

type ToastOptions = {
  message: string;
  duration?: number;
  color?: "danger" | "success" | "warning";
};

export function useToast() {
  const [present] = useIonToast();

  const presentToast = ({ message, duration = 2000, color = "success" }: ToastOptions) => {
    return present({
      message,
      duration,
      color,
      position: "top",
      cssClass: "toast-top-right",
    });
  };

  return { presentToast };
}
